import Head from 'next/head';
import React from 'react';
import Meta from '../../components/Meta';

const Tarms = () => {
	return (
		<div>
			<Meta title="Үйлчилгээний нөхцөл || Bondgor Cargo" />
			<div className="pt-[5.5rem] lg:pt-24">
				{/* <!-- TOS --> */}
				<section className="dark:bg-jacarta-800 relative py-16 md:py-24">
					<picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
						<img src="/images/gradient_light.jpg" alt="gradient" className="h-full w-full" />
					</picture>
					<div className="container">
						<h1 className="font-display text-jacarta-700 text-center text-4xl font-medium dark:text-white">
							КОМПАНИЙН ҮЙЛ АЖИЛЛАГААНЫ ТУХАЙ
						</h1>
						<div className="article-content mx-auto max-w-[48.125rem]">
							<h2 className="text-base">НЭГ. ЕРӨНХИЙ ЗҮЙЛ</h2>
							<p>
								1.1 Энэхүү журмаар BEMO Express ХХК-ийн (цаашид FACEBOOK, PAGE нэр-Bondgor Cargo -гэнэ) захиалгат худалдааны үйлчилгээ, түүнтэй холбоотой үүсэх бүх төрлийн харилцааг зохицуулна.
							</p>
							<p>
								1.2 FACEBOOK, PAGE нь БНХАУ-д байрлалтай онлайн болон онлайн бус дэлгүүр, нийлүүлэгчээс хэрэглэгчийн сонгон захиалсан бараа бүтээгдэхүүнийг худалдан авч тээвэрлэх, нийлүүлэх үйлчилгээ үзүүлнэ.
							</p>
							<p>
								1.3 Энэхүү журмын хэрэгжилтэнд FACEBOOK, PAGE болон үйлчлүүлэгч хамтран хяналт тавина.
							</p>
							<h2>ХОЁР. ЗАХИАЛГА</h2>
							<p>
								2.1 FACEBOOK, PAGE нь БНХАУ үйл ажиллагаа эрхэлдэг онлайн болон онлайн бус дэлгүүрүүд, нийлүүлэгчдээс хэрэглэгчийн сонгон захиалсан бараа бүтээгдэхүүнийг худалдан авч, тээвэрлэн үйлчилнэ.
							</p>
							<p>
								2.2 Захиалгын үйлчилгээ нь FACEBOOK, PAGE захиалгат худалдааны нэгдсэн системээр болон оффис дээр биеээр ирж захиалах бөгөөд хэрэглэгч захиалга өгснөөс эхлэн худалдан авалт, тээвэрлэлт, төлбөр төлөлт, барааг хүлээлгэн өгөх хүртэлх бүх үйл явц энэ системээр удирдагдана.
							</p>
							<p>
								2.3 Захиалгын үнийг хэрэглэгч зөвшөөрөн баталгаажуулж, төлбөр хийгдсэнээс хойш 2 цагийн дотор төлбөр баталгаажих ба захиалга төлбөр төлсөн гэсэн төлөвтэй болсон үед автоматаар илгээгдэнэ. Захиалга илгээгдсэнээс хойш Хятад дэлгүүр 12-76 цагийн дотор захиалгыг хүлээж авч хариу илгээдэг.
							</p>

							<p>Хэрэглэгч төлбөр төлсөний дараа сайт дах Миний захиалгууд хэсэгрүүгээ орж захиалгын төлөв (захиалга хийгдсэн болон цуцлагдсан эсэх, барааны байршил болон ирсэн эсэх)-ийг хянана.
							</p>
							<p>
								2.4 Бараа Уб-т ирсэний дараа захиалагч өөрийн биеэр болон албан ёсны төлөөлөгчөө илгээж оффисоос ирж авах, түүнчлэн хүргэлтээр болон хөдөө орон нутагруу унаанд тавиулж авах боломжтой. Барааг хүргэлтээр болон унаанд тавьсанаас хойших бүх үйл явцыг захиалагч өөрөө хариуцна.
							</p>

							<h2>ГУРАВ. ҮНЭ</h2>

							<p>
								3.1 Захиалгын үнийг сайтын захиалгын систем тооцоолон гаргана.

							</p>

							<p>
								3.2 Захиалгын үнэнд дараах зүйлсийг оруулан тооцох бөгөөд Монголд ирсэн барааны бодит жин болон овор хэмжээнээс хамааран тээвэрлэлтийн үнийн дүн өөрчлөгдөж болно.<br />
								Үүнд: <br />БНХАУ-д :<br />
								• Барааны үнэ<br />
								• Тухайн барааны ЭРЭЭН хот хүртлэх хүргэлтийн үнэ<br />
								Монгол улсад:<br />
								• БНХАУ-аас Монгол хүртэлх тээврийн зардал (тээврийн зардал дэлгүүр дэлгүүрээр тусдаа тооцогдох ба 1кг хүртэл бараа 3500₮ цаашлаад кг тутамд 2000₮ нэмэгдэнэ. Овор ихтэй ачааг 1 метр кубыг 1000 юань -р тооцно)<br />
								• Монгол улсын гаалийн татвар (Монгол улсын гаалийн татварын дагуу)<br />
							</p>
							<p>
								3.3 Хэрэглэгч FACEBOOK, PAGE-н миний захиалга хэсгээс тээврийн зардлыг дэлгэрэнгүйгээр харах боломжтой.
							</p>

							<h2>ДӨРӨВ. ТӨЛБӨР</h2>

							<p>
								4.1 Хэрэглэгч бараа захиалгын үнийн 100 хувийг төлснөөр захиалгыг баталгаажсан гэж үзэн худалдан авалтыг захиалгын журмын 2.4-т заасан хугацаанд хийнэ.
							</p>
							<p>
								4.2 Бараа захиалгын үнэ автоматаар MNT (төгрөг)-р бодогдож хийгдэх бөгөөд систем хөрвүүлэхдээ тухайн өдрийн CNY зарах ханш дээр Монгол банкны гадаад гүйглээний шимтгэл болох 3%-ыг нэмж тооцогдон хөрвүүлэгдэнэ.
							</p>
							<p>
								4.3 Төлбөрийг бэлнээр болон дансаар төлөх боломжтой.
							</p>

							<h2>ТАВ. ТЭЭВЭРЛЭЛТ, БАРАА ОЛГОЛТ</h2>

							<p>
								5.1 Тээвэрлэлт нь БНХАУ дахь хүргэлт, БНХАУ-аас Монгол хүртэлх тээвэрлэлт гэсэн 2 үндсэн үе шатаас бүрдэнэ.
							</p>
							<p>
								5.2 БНХАУ дахь хүргэлт нь тухайн дэлгүүр, нийлүүлэгчийн ашиглаж буй дотоодын хүргэлтийн үйлчилгээгээр нийлүүлэгч хүргэлтийг бүрэн хариуцна.
							</p>
							<p>
								5.3 Бараа бүтээгдэхүүн Bondgor Cargo-ын БНХАУ дахь агуулахад хүргэгдэн, Монгол улсруу ачигдсанаас хойш 10-20  хоногийн дотор хэрэглэгчид хүрнэ.
							</p>
							<p>
								5.4 Захиалгыг хэрэглэгчид олгох үед хэрэглэгч бараа бүтээгдэхүүнийг сайтар шалган, эвдрэл гэмтлийг нягтлан үзсэний дараа гарын үсэг зурж, хүлээн авна. Барааг хэрэглэгч хүлээн авснаас хойш гарсан эвдрэл гэмтэл болон бусад асуудлуудад FACEBOOK, PAGE хариуцлага хүлээхгүй.
							</p>
							<h2>ЗУРГАА. ХҮРГЭЛТ</h2>
							<p>6.1 FACEBOOK, PAGE хэрэглэгчийн хүсэлд нийцүүлэн нийслэл хот, хөдөө орон нутагт захиалгын бараа бүтээгдэхүүнийг хүргэх үйлчилгээ үзүүлнэ.</p>
							<p>6.2 Хүргэлтийн үйлчилгээ авах эсэхийг хэрэглэгч захиалга Уб-т ирсэний дараа мэдэгдэх бөгөөд хүргүүлэх газрын байрлалаас шалтгаалан хүргэлтийн үнэ тогтоогдож, тээврийн зардал дээр нэмж тооцогдоно.</p>
							<p>6.3 Улаанбаатар хотод хүргэлтийн үйлчилгээг бүсчилсэн үнийн тарифаар гүйцэтгэнэ.</p>
							<p>6.4 Орон нутгийн хүргэлтийг хот хоорондын тээврийн үйлчилгээний байгууллагуудтай хамтран гүйцэтгэнэ.</p>

							<h2>ДОЛОО. БАРАА БУЦААЛТ</h2>
							<p>7.1 БНХАУ дахь дэлгүүр, нийлүүлэгчийн бараа буцаах хугацаа, журамд нийцүүлэн хэрэглэгчийн хүсэлтээр Монголд ирсэн бараа (размер өнгө буруу, ажиллахгүй, хадгалалтын хугацаа дууссан, тээвэрлэлтийн явцад гэмтсэн,) бүтээгдэхүүнийг үнэгүй буцааж болох бусад тохиолдолд Bondgor Cargo  ХХК-ийн тухайн үеийн ханшаар буцааж болно. Бараа бүтээгдэхүүний БНХАУ дахь дэлгүүр, нийлүүлэгчид очих хугацаа нь тухайн дэлгүүрийн бараа буцаах журамд заагдсан хугацаанд багтсан байх ёстой. Жич: Хил гааль хаалттай үед Хятад улсруу буцаан явуулах боломжгүй тул зайлшгүй хэрэгтэй үед SF Cargo-той хамтарч ажиллаж буцааж болно.</p>
							<p>7.2 Бараа бүтээгдэхүүнийг буцаахтай холбогдон гарах тээвэрлэлт, торгууль зэрэг бүх зардлыг хүсэлт гаргасан хэрэглэгч хариуцна.</p>
							<p>7.3 Буцаагдсан бараанд ноогдох тээвэрлэлт, үйлчилгээний хөлс, бусад зардал нь буцаан олгогдохгүй ба барааны үндсэн үнээс нийлүүлэгч талаас нэхэмжилж болох зардлыг хассан дүнгээр нийлүүлэгчээс барааны төлбөр бүрэн буцан шилжиж орсон тохиолдолд хэрэглэгчид олгоно.</p>

							<h2>НАЙМ. ХОРИОТОЙ БОЛОН ТУСГАЙ ЗӨВШӨӨРӨЛТЭЙ БАРАА</h2>
							<p>8.1 Гаалиар тээвэрлэхийг хориглодог бүтээгдэхүүний жагсаалтанд орсон бүх төрлийн бараа бүтээгдэхүүний захиалга хийхгүй. <br />
								Тухайлбал:<br />
								• Галт зэвсэг, байлдааны галт хэрэгсэл, тэсэрч дэлбэрэх болон цацраг идэвхит бодис, түргэн шатамхай бодис, орчиндоо аюул учруулж болох бусад хэрэгсэл;<br />
								• Хортон ургамал, амьтан;<br />
								• Хар тамхи, мансууруулах буюу хордуулах бодис;<br />
								• Хуульд өөрөөр заагаагүй бол Монгол Улсын болон гадаад улсын мөнгөн тэмдэгт;<br />
								• Түргэн муудах хүнсний бүтээгдэхүүн;<br />
								• Садар самууныг сурталчилсан хэвлэл, ном зохиол, зураг, кино, дүрс бичлэг, бусад материал;<br />
								• Хууль тогтоомжоор хориглосон бусад зүйл<br />
							</p>
							<p>8.2 Тусгай зөвшөөрлийн лиценз шаарддаг бараа бүтээгдэхүүн захиалах тохиолдолд хэрэглэгч тухайн бүтээгдэхүүний тусгай зөвшөөрлийн лицензтэй бол FACEBOOK, PAGE -аар Монгол улсын гааль хүртэлх гүйцэтгэлийг гүйцэтгүүлж болно.
							</p>
							<h2>ЕС. ХЯМДРАЛ УРАМШУУЛАЛТАЙ БАРАА БҮТЭЭГДЭХҮҮНИЙ ЗАХИАЛГА</h2>
							<p>9.1 Онлайн дэлгүүрүүдийн бүх төрлийн хямдралтай худалдаанд хамрагдаж болох ба хямдралын хугацаа нь 2.4 зүйлд заасан бараа худалдан авалтын хугацаанд багтах ёстой.</p>
							<p>9.2 Баталгаат эх сурвалж бүхий купонтой худалдааг тухайн дэлгүүрийн журмын дагуу гүйцэтгэнэ.</p>

							<h2>АРАВ. ХАРИУЦЛАГА</h2>
							<p>10.1 Хэрэглэгчийн сонгосон захиалгын бүтээгдэхүүнүүд нь FACEBOOK, PAGE-тай хамааралгүй БНХАУ-ын дэлгүүр, нийлүүлэгчийн бараа бүтээгдэхүүн тул тэдгээрийн чанар бусад үзүүлэлтүүдэд FACEBOOK, PAGE хариуцлага хүлээхгүй.</p>
							<p>10.2 Дэлгүүрийн найдвартай байдал, бараа бүтээгдэхүүний сонголт, чанартай холбоотой асуудлыг хэрэглэгч бүрэн хариуцна</p>
							<p>10.3 Хэрэглэгч нь авсан бараагаа FACEBOOK, PAGE-аар дамжуулан Ард Даатгал Компаниар даатгуулах боломжтой бөгөөд даатгалын үнэ нь барааны үнийн дүнгээс шууд хамаарна.</p>
							<p>10.4 FACEBOOK, PAGE-н БНХАУ дахь салбарын хаягаар дур мэдэн захиалга хийхийг хориглоно. Зөвшөөрөлгүйгээр хийсэн захиалгад FACEBOOK, PAGE хариуцлага хүлээхгүй.</p>

							<h2>АРВАН НЭГ. БУСАД</h2>
							<p>11.1 Захиалгын бараа бүтээгдэхүүн дууссан, ямар нэгэн байдлаар захиалга цуцлагдсан (барааны нөөц дуусах, тухайн дэлгүүр захиалгын доод болон дээд лимиттэй эсвэл Эрээн хотруу цөөн тооны бараа илгээхээс татгалзах, тээврийн зардал нэхэх, түүнчлэн тухайн дэлгүүр журмын дагуу 76 цагийн дотор илгээх ёстой боловч илгээгээгүй удсан мөн илгээсэн ч хятад карго дотроо алга болсон) тохиолдолд хэрэглэгч захиалгыг өөр бүтээгдэхүүнээр солих, нэмэлт төлбөр төлөх эсвэл тухайн барааны захиалгыг цуцлаж мөнгөө 100% буцаан авч болно.</p>
							<p>11.2 Захиалгыг цуцласан тохиолдолд дууссан бараа бүтээгдэхүүний үнийг хасан захиалгын нийт үнэ бодогдоно.</p>
							<p>11.3 Тухайн нөхцөлд дууссан боловч тодорхой хугацааны дараа тухайн бараа онлайн дэлгүүрт ирэхийг мэдэгдсэн тохиолдолд худалдан авалтыг үргэлжлүүлэх эсэхийг хэрэглэгчийн хүсэлтээр шийдвэрлэнэ.</p>

						</div>
					</div>
				</section>
				{/* <!-- end TOS --> */}
			</div >
		</div >
	);
};

export default Tarms;
